import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsFinanceByDestination(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS_FINANCE_BY_DESTINATION,
		ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_DESTINATION].GET_REPORTS_FINANCE_BY_DESTINATION,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_DESTINATION].GET_REPORTS_FINANCE_BY_DESTINATION]: _getReportsFinanceByDestination,
}